<div [class]="playerClass">
    <div class="word-flasher-player__word-container">
        @if (currentItem.text) {
        <div [innerHTML]="currentItem.text"></div>
        } @if (currentItem.image) {
        <img [src]="currentItem.image" />
        } @if (audioId) {
        <bbvms-audio
            hidden
            autoplay="true"
            [data-audio-id]="audioId"
        ></bbvms-audio>
        }
    </div>
    @if (controlsActive && !sequenceDone) {
    <div class="word-flasher-player__controls">
        <app-button
            class="outset-with-icon outset-with-icon--smaller word-flasher-player__control"
            (click)="startOver()"
        >
            <i class="fas fa-redo"></i>
            <span i18n>Opnieuw</span>
        </app-button>
        <app-button
            class="outset-with-icon outset-with-icon--smaller word-flasher-player__control word-flasher-player__control--stop"
            (click)="closePlayer()"
        >
            <i class="fas fa-times variant-stop"></i>
            <span i18n class="variant-stop">Stoppen</span>
        </app-button>
        <app-button
            class="outset-with-icon outset-with-icon--smaller word-flasher-player__control"
            (click)="continueSequence()"
        >
            <i class="fas fa-play"></i>
            <span i18n>Doorgaan</span>
        </app-button>
    </div>
    } @if (sequenceDone) {
    <div class="word-flasher-player__controls">
        <app-button
            class="outset-with-icon outset-with-icon--smaller word-flasher-player__control"
            (click)="goPrevious()"
            [disabled]="currentItemIndex === 0"
        >
            <i class="fas fas fa-arrow-left"></i>
            <span i18n>Vorige</span>
        </app-button>
        <app-button
            class="outset-with-icon outset-with-icon--smaller word-flasher-player__control word-flasher-player__control--stop"
            (click)="closePlayer()"
        >
            <i class="fas fa-times variant-stop"></i>
            <span i18n class="variant-stop">Stoppen</span>
        </app-button>
        <app-button
            class="outset-with-icon outset-with-icon--smaller word-flasher-player__control"
            (click)="goNext()"
            [disabled]="currentItemIndex + 3 > sequence.length"
        >
            <i class="fas fas fa-arrow-right"></i>
            <span i18n>Volgende</span>
        </app-button>
    </div>
    }
</div>
